const SchoolCenters = {
  NoAvailable: -1,
  PrivateCenter: 1487,
  PublicCenter: 1862,
};
export default SchoolCenters;
